import { SkeletonLoader, typographyV2 } from '@toggle/design-system';
import { NumericalCellValueStyle } from '@toggle/helpers';
import styled from 'styled-components';

const colors = {
  [NumericalCellValueStyle.Positive]: 'var(--viz-bullish)',
  [NumericalCellValueStyle.Negative]: 'var(--viz-bearish)',
  [NumericalCellValueStyle.Neutral]: 'var(--text-default)',
};

const backgroundColors = {
  [NumericalCellValueStyle.Positive]: 'var(--viz-bullish-soft)',
  [NumericalCellValueStyle.Negative]: 'var(--viz-bearish-soft)',
  [NumericalCellValueStyle.Neutral]: 'transparent',
};

export const TitleLabel = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-default);
`;

export const SubtitleLabel = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const ChangePill = styled.div<{
  $numericalStyle: NumericalCellValueStyle;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${typographyV2.uiSm};
  color: ${({ $numericalStyle }) => colors[$numericalStyle]};
`;

export const ChangeLabel = styled.div<{
  $numericalStyle: NumericalCellValueStyle;
}>`
  border: 1px solid
    ${({ $numericalStyle }) => backgroundColors[$numericalStyle]};
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: ${({ $numericalStyle }) =>
    backgroundColors[$numericalStyle]};
  padding: 2px 4px 2px 4px;
`;

export const HorizonLabel = styled.div<{
  $numericalStyle: NumericalCellValueStyle;
}>`
  border: 1px solid
    ${({ $numericalStyle }) => backgroundColors[$numericalStyle]};
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  padding: 2px 4px 2px 4px;
`;

export const Root = styled.div`
  width: 100%;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  cursor: pointer;

  &:hover {
    background-color: var(--surface-hover);
  }
`;

export const IconsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const LoadingSkeleton = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '132px',
        borderRadius: '8px',
      },
    },
  ],
})``;
